import { render, staticRenderFns } from "./employers.component.vue?vue&type=template&id=32654355&scoped=true&lang=html&"
import script from "./employers.component.vue?vue&type=script&lang=js&"
export * from "./employers.component.vue?vue&type=script&lang=js&"
import style0 from "./employers.component.vue?vue&type=style&index=0&id=32654355&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32654355",
  null
  
)

export default component.exports